import { BaseLayout } from "@/components/layout";
import { HeroBanners } from "@/components/home/HeroBanners";
import { ShopBenefits } from "@/components/home/ShopBenefits";
import { ProductTabs } from "@/components/home/ProductTabs";
import { CategoryTabs } from "@/components/home/CategoryTabs";
import { RecentlyPurchased } from "@/components/home/RecentlyPurchased";
import { TopProfiles } from "@/components/home/TopProfiles";
import { SEOHead, OrganizationSchema } from "@/components/seo/SEOHead";
import {
  heroBanners,
  recentPurchases,
  productTabs,
  categoriesByType,
  categoriesByCollection,
  specialCategories,
  topProfiles,
} from "@/data/homeData";

const Index = () => {
  return (
    <>
      <SEOHead />
      <OrganizationSchema />
      
      <BaseLayout footerVariant="full">
        {/* Hero Banners */}
        <HeroBanners banners={heroBanners} />
        
        {/* TOP Profiles/Interpreti - right after hero */}
        <TopProfiles title="TOP Interpreti" profiles={topProfiles} />
        
        {/* Products Section with Centered Tabs */}
        <ProductTabs title="Objavte náš výber" tabs={productTabs} />
        
        {/* Categories Section with Tabs */}
        <CategoryTabs 
          title="Nakupovať podľa" 
          tabs={[
            { id: "typ", label: "Typ produktu", categories: categoriesByType },
            { id: "kolekcie", label: "Kolekcie", categories: categoriesByCollection },
            { id: "specialne", label: "Špeciálne", categories: specialCategories },
          ]} 
        />
        
        {/* Recently Purchased */}
        <RecentlyPurchased purchases={recentPurchases} />
        
        {/* Shop Benefits - at the bottom */}
        <ShopBenefits />
      </BaseLayout>
    </>
  );
};

export default Index;
